import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {
  if (id)
    return `/v1/companies/${
      auth.getCurrentUser().company_id
    }/visas-ledger-types/${id}`;
  else
    return `/v1/companies/${auth.getCurrentUser().company_id}/visas-ledger-types`;
}

export function getLedgerTypes(companyId) {
  return http.get(`/v1/companies/${companyId}/visas-ledger-types`);
}

export function deleteLedgerType(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveLedgerType(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function updateLedgerType(supplier) {
  return http.put(supplierStoreUrl(supplier.id), supplier);
}

export function updateLedgerTypeStatus(supplier) {
  return http.get(
    `/v1/companies/${auth.getCurrentUser().company_id}/visas-ledger-types/${
      supplier.id
    }/status`
  );
}

export function getLedgerType(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}
